import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { paths } from '@/constants';
import { useOptionalSearchParamAsNumber, useToken } from '@/hooks';
import { useWorkspace } from '@/hooks/useWorkspace';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const token = useToken();
    const project_id = useOptionalSearchParamAsNumber('project_id');
    const switchWorkspace = useWorkspace();

    useEffect(() => {
        if (project_id) {
            switchWorkspace({ projectID: project_id });
        }
    }, [project_id, switchWorkspace]);

    if (!token) {
        return <Navigate to={paths.sign.index} replace />;
    }

    return children;
};
